module.exports = __webpack_public_path__ + "static/media/20-4.dfb5eaa2.mp3";